import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { AuthResponse } from "@/api/types";
import { normalizePhone } from "@/lib/normalize-phone";
import { transitionSession } from "@/lib/session-transition";

interface SignUpInput {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  mobile_number?: string;
  country?: string;
  terms_accepted?: boolean;
}

export function useSignUp() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SignUpInput) => {
      const json = data.mobile_number
        ? { ...data, mobile_number: normalizePhone(data.mobile_number) }
        : data;
      return api.post("users", { json }).json<AuthResponse>();
    },
    onSuccess: (data, _variables, _result, context) => {
      transitionSession(queryClient, data.user, context);
    },
  });
}
